import React, { useState } from 'react';
import {
  ErrorText,
  CardContainer,
  PlanHeader,
  PlanFooter,
  PlanBody,
  Price,
  FieldsContainer,
  PlanLabel,
  BlockContainer,
} from './styles';
import { Button } from 'components/Button/RoundButton';
import { OuterContainer, SectionTitle, TextInput } from '../styles';

export const Plan = ({ plan, updatePlan }) => {
  const [paymentPlan, setPaymentPlan] = useState(JSON.parse(JSON.stringify(plan)));
  const [error, setError] = useState('');
  const [showUpdatePlanForm, setShowUpdatePlanForm] = useState(false);

  const updateFields = (field, value, isPrice) => {
    if (!value.trim()) setError('All fields are required');
    else setError('');
    const copyOfPaymentPlan = JSON.parse(JSON.stringify(paymentPlan));
    if (isPrice) copyOfPaymentPlan.price[field] = value;
    else copyOfPaymentPlan[field] = value;
    setPaymentPlan(copyOfPaymentPlan);
  };

  const renderUpdatePlanForm = () => {
    return (
      <>
        <FieldsContainer>
          <BlockContainer>
            <PlanLabel>Name</PlanLabel>
            <TextInput
              type="text"
              padding="5px"
              margin="0px"
              height="30px"
              onChange={(e) => updateFields('name', e.target.value)}
              placeholder="Name*"
              value={paymentPlan.name}
            />
          </BlockContainer>
          <BlockContainer>
            <PlanLabel>Credits</PlanLabel>
            <TextInput
              type="text"
              padding="5px"
              margin="0px"
              height="30px"
              onChange={(e) => updateFields('credits', e.target.value)}
              placeholder="Credits*"
              value={paymentPlan.credits}
            />
          </BlockContainer>
          <BlockContainer>
            <PlanLabel>Price(SEK)*</PlanLabel>
            <TextInput
              type="number"
              padding="5px"
              margin="0px"
              height="30px"
              onChange={(e) => updateFields('SEK', e.target.value, true)}
              placeholder="Price(SEK)*"
              value={paymentPlan.price.SEK}
            />
          </BlockContainer>
          <BlockContainer>
            <PlanLabel>Price(EUR)*</PlanLabel>
            <TextInput
              type="number"
              padding="5px"
              margin="0px"
              height="30px"
              onChange={(e) => updateFields('EUR', e.target.value, true)}
              placeholder="Price(EUR)*"
              value={paymentPlan.price.EUR}
            />
          </BlockContainer>
        </FieldsContainer>
        {error && <ErrorText>{error}</ErrorText>}
        <Button
          small
          primaryBlue
          primaryGreenBorder
          margin="15px 0 0 0"
          onClick={() => {
            if (!error) {
              updatePlan(paymentPlan);
              setShowUpdatePlanForm(false);
            }
          }}
        >
          Update
        </Button>
      </>
    );
  };

  return (
    <OuterContainer>
      <SectionTitle>Plans</SectionTitle>
      {showUpdatePlanForm && renderUpdatePlanForm()}
      {!showUpdatePlanForm && (
        <CardContainer>
          <PlanHeader>{paymentPlan.name}</PlanHeader>
          <PlanBody>
            {Object.keys(paymentPlan.price).map((key, index) => (
              <Price key={index}>
                {key} {paymentPlan.price[key]}
              </Price>
            ))}
            {paymentPlan.limitless && <>(Limitless)</>}
          </PlanBody>
          <PlanFooter>
            <Button
              small
              primaryBlue
              primaryGreenBorder
              removeMargin
              onClick={() => {
                setShowUpdatePlanForm(true);
              }}
            >
              Update
            </Button>
          </PlanFooter>
        </CardContainer>
      )}
    </OuterContainer>
  );
};
